import React from 'react'

const Button = ({ children, variant, fontColor, onClick, disabled }) => {

    return (
        <button disabled={disabled} onClick={onClick} className={`${fontColor} text-xs font-bold font-dmsans leading-[14.40px] w-full h-full py-5 ${variant}`}>{children}</button>
    )
}

export default Button
